// app/studente/studenti.js

(function () {
    'use strict';
    var controllerId = 'studente';
    angular.module('app').controller(controllerId, ['common', 'bootstrap.dialog', '$rootScope', '$routeParams', '$filter', '$uibModal', 'datacontext', 'sectionMenu', studente]);

    function studente(common, bDialog, $rootScope, $routeParams, $filter, $uibModal, datacontext, sectionMenu) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard
        var vm = this;
        vm.title = 'Allievi';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        //Gestione sola lettura
        vm.readOnly = !$rootScope.isAuthorized('SUPER') && !$rootScope.isAuthorized('GESTORE');
        vm.super = $rootScope.isAuthorized('SUPER');
        vm.gestDid = $rootScope.isAuthorized('GESTORE');
        vm.objName = "Allievo"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.page = 1;
        vm.loading = false;
        vm.addDisabled = !vm.super && !vm.gestDid;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        vm.changed = false;

        //Elenchi dettaglio
        vm.list = {};
        vm.list.ordine = ['Codice Fiscale', 'Email', 'Nominativo'];
        //vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[2];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            cerca();
        };

        //Filtro
        vm.filter = {};
        vm.filter.nominativo = ' ';
        vm.filter.classeId = 0;

        //filter per Anno: default l'anno corrente o per anno impostato gi� in altre aree
        if ($rootScope.annoScolastico == 0)
            vm.fAnno = $rootScope.annoCorrente || (new Date).getFullYear();
        else
            vm.fAnno = $rootScope.annoScolastico;
        vm.filter.anno = vm.fAnno;

        //Elenchi per filtri e finestra modale di Create e Update
        vm.istituti = [];
        vm.classi = [];
        vm.societa = [];
        vm.province = [];
        vm.comuni = [];
        vm.listUsername = [];
        vm.classiStudente = [];

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;

        vm.get = getRecord;
        vm.add = addModal;
        vm.update = updateItem;
        vm.delete = deleteItem;

        vm.getRecord = getRecord;
        vm.getComuni = getComuni;
        vm.getClassiStudente = getClassiStudente;
        vm.annoChanged = function () {
            vm.classi = getClassi();
            cerca();
        };

        vm.addClasse = addClasse;
        vm.deleteClasse = deleteClasse;

        //Gestione Attach
        vm.fAttach = {};
        vm.filterAttach = '';
        vm.setfAttach = setfAttach;
        vm.list.attach = [];
        vm.getListAttach = getListAttach;
        vm.tSourceCode_def = 'ALV';
        vm.addAttach = addAttach;
        vm.deleteAttach = deleteAttach;

        //Gestione account
        vm.getAccount = getAccount;
        vm.updateAccount = updateAccount;
        vm.resetPassword = resetPassword;
        vm.invioCredenziali = invioCredenziali;

        //datapicker
        vm.open = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = false;
            vm.opened2 = false;
            vm.opened3 = false;
            if (iOpened == 1)
                vm.opened1 = true;
            else if (iOpened == 2)
                vm.opened2 = true;
            else if (iOpened == 3)
                vm.opened3 = true;
        };

        vm.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                vm.record.dtAmmesso = '';
                vm.changed = true;
            }
            else if (iOpened == 2) {

                vm.record.dtDimesso = '';
                vm.changed = true;
            }

        };

        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';
        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getClassi(), getProvince(), getSocieta(), getTSource(vm.tSourceCode_def), getTAttach(vm.tSourceCode_def)];
            common.activateController(promises, controllerId)
                    .then(function () {
                        if ($routeParams.StudenteId != null) {
                            setView('detail');
                            getRecord($routeParams.StudenteId, 0);
                        }
                    });
        }


        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.nominativo = vm.fNominativo == null ? '' : vm.fNominativo;
            vm.filter.classeId = vm.fClasseId == null ? 0 : vm.fClasseId;
            vm.filter.anno = vm.fAnno == null ? -1 : vm.fAnno;
            if (vm.filter.anno != $rootScope.annoScolastico)
                $rootScope.annoScolastico = vm.filter.anno;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.super_studente_countAllByUsername(vm.filter.anno, vm.filter.nominativo, vm.filter.classeId).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.super_studente_getAllByUsername(vm.pageSize, vm.page, vm.filter.anno, vm.filter.nominativo, vm.filter.classeId, vm.ordine).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    data.forEach(function (item) {
                        vm.records.push(item);
                    });
                }
                vm.loading = false;
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
            return datacontext.studente_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;

                getComuni(vm.record.ProvinciaId);
                getClassiStudente();                
                
                setView('detail');
            });
        }

        function addRecord(id) {
            return datacontext.studente_get(id).then(function (data) {
                vm.records.push(data);
                vm.countRecords++;
            });
        }

        function updateItem() {
            //Nota qui la gestione dell'errore � inversa, il server torna l'oggetto modificato anzicch� il NOCONTENT
            return datacontext.studente_update(vm.record).then(function (data) {
                if (!data) {
                    cerca();
                    logSuccess('Dati salvati');
                }
                    
                else
                    logError('Impossibile salvare i dati');
            });
        }

        function deleteItem(item) {
            if (item.Attivo) {
                logError('Non � possibile eliminare un allievo attivo');
                return;
            }

            var msg = ' L\'allievo ' + item.Cognome + ' ' + item.Nome;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.studente_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');

                    var index = vm.records.indexOf(item);
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }

        //Elenchi Parametri
        function getClassi() {
            var anno = vm.fAnno == null ? -1 : vm.fAnno;
            
            return datacontext.classe_getAllList(anno).then(function (data) {
                return vm.classi = data;
            });
        }

        function getSocieta() {
            if (!vm.super)
                return;

            return datacontext.societa_getAllList().then(function (data) {
                return vm.societa = data;
            });
        }

        function getIstituti() {
            return datacontext.istituto_getAllList().then(function (data) {
                return vm.istituti = data;
            });
        }

        function getClassiStudente() {
            return datacontext.classe_getAllByStudenteId(vm.record.Id, true).then(function (data) {
                return vm.classiStudente = data;
            });
        }        

        function getProvince() {
            if (vm.province.length > 0) return;

            datacontext.arrProvincie().then(function (data) {
                vm.province = data;
            });
        }

        function getComuni(idprov) {
            if (!idprov || idprov == 0) return vm.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.comuni = data;
            });
        }
       
        //Gestione account
        function getAccount() {
            datacontext.user_getByUsername(vm.record.Username).then(function (data) {
                vm.account = data;
                vm.account.DtAttivazione = $filter('date')(data.DtAttivazione, 'dd/MM/yyyy');
            });
        }

        function updateAccount() {
            vm.account.DtAttivazione = common.stringToDate(vm.account.DtAttivazione);
            return datacontext.user_update(vm.account).then(function (data) {
                if (!data) {
                    logSuccess('Dati salvati');
                }
                else
                    logError('Impossibile salvare i dati');
            });
        }

        //Manda una email all'utente con un link di accesso al Reset Password
        //dove l'utente pu� inserire una nuova password per il suo account
        function resetPassword() {
            var msg = 'Sar� inviata un\'email all\'utente ' + vm.account.Username + ' ' + 'contenente le istruzioni per eseguire il reset della password. Continuare?';
            bDialog.confirmationDialog('Reset Password', msg, 'OK').then(function () {
                return datacontext.user_resetPassword(vm.account.Email).then(function (data) {
                    if (data != "204") return logError('Impossibile eseguire l\'operazione');

                    logSuccess('Operazione effettuata con successo');
                });
            });
        }

        function invioCredenziali() {
            var msg = 'Sar� inviata un\'email all\'utente ' + vm.account.Username + ' ' + 'contenente le credenziali per l\'accesso alla piattaforma. Continuare?';
            bDialog.confirmationDialog('Invio Credenziali', msg, 'OK').then(function () {
                return datacontext.user_invioCredenziali(vm.account.Email).then(function (data) {
                    if (data != "204") return logError('Impossibile eseguire l\'operazione');
                    logSuccess('Operazione effettuata con successo');
                });
            });
        }

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {
            //getSocieta();//nuovo
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/studente/modal/studenteAdd.html?version=43',
                controller: 'studenteAdd',
                resolve: {
                    classi: function () {
                        return vm.classi;
                    },
                    classeId: function () {
                        return null;    //ClasseId non impostato - da selezionare in inserimento
                    },
                    //societa: function () {
                    //    return vm.societa;
                    //},
                    societaId: function () {
                        return null;    //SocietaId non impostato - da selezionare in inserimento
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore durante la creazione del dato');

                logSuccess('Dato salvato con successo');
                addRecord(returnItem.Id);
            });
        }

        // Add classe
        function addClasse() {
            var anno = $rootScope.annoCorrente || (new Date).getFullYear();
            var societaId = vm.record.SocietaId || 0;            
            datacontext.super_classe_getAllList(anno, societaId).then(function (data) {                
                var modalInstance = $uibModal.open({
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: '/app/studente/modal/studenteClasseAdd.html?version=43',
                    controller: 'studenteClasseAdd',
                    resolve: {
                        classi: function () {
                            return data;
                        },
                        studente: function () {
                            return vm.record;
                        }
                    }
                });

                modalInstance.result.then(function () {
                    getClassiStudente();
                    logSuccess('Dato salvato con successo');
                });
            });
        }

        function deleteClasse(classe) {
            if (classe.Attivo) {
                logError('Non � possibile eliminare una classe attiva');
                return;
            }

            var msg =' L\'allievo ' + vm.record.Cognome + ' ' + vm.record.Nome + ' dalla Classe ' + classe.classe;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.studente_classeDelete(vm.record.Id, classe.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');

                    var index = vm.classiStudente.indexOf(classe);
                    vm.classiStudente.splice(index, 1);
                });
            });
        }

        //Gestione Attach
        function setfAttach() {
            if (vm.checkfAttach == false) {
                vm.fAttach.TAttachId = '';
            }
        }

        function getTSource(code) {
            if (!code) return;

            return datacontext.tSource_getByCode(code).then(function (data) {
                return vm.tSource = data;
            });
        }

        function getTAttach(code) {
            if (!code) return;

            return datacontext.tAttach_getAllList(code, 0, 0, 0).then(function (data) {
                return vm.tAttach = data;
            });
        }

        function getListAttach(id) {
            if (!id) return;

            return datacontext.attach_getAll(0, 0, vm.tSourceCode_def, 0, id, vm.fAttach.TAttachId, '').then(function (data) {
                vm.list.b_attach = true;
                return vm.list.attach = data;
            });
        }

        function addAttach(item) {
            var recTSource = { Id: vm.tSource.Id, Name: vm.tSource.Name };
            var recSource = { Id: vm.record.Id, Name: vm.record.Cognome + ' ' + vm.record.Nome };

            var modalInstance = $uibModal.open({
                templateUrl: '/app/attach/modal/attachAdd.html?version=43',
                controller: 'attachAdd',
                resolve: {
                    tSource: function () {
                        return [recTSource];
                    },
                    tSourceCode: function () {
                        return vm.tSource.Code;
                    },
                    tSourceId: function () {
                        return vm.tSource.Id;
                    },
                    source: function () {
                        return [recSource];
                    },
                    sourceId: function () {
                        return recSource.Id;
                    },
                    tAttach: function () {
                        return null;
                    },
                    tAttachId: function () {
                        return null;
                    },
                    attach: function () {
                        return item;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "406") return logError('Errore: formato allegato non corretto! ');
                if (returnItem == "400") return logError('Errore registrazione dati [' + returnItem + ']');

                logSuccess('Dato salvato con successo! ');
                getListAttach(vm.record.Id);
                //vm.record.stat_numAttach = vm.record.stat_numAttach + 1;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        }

        function deleteAttach(item) {
            var msg = ' Allegato ' + item.Name;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.attach_delete(item.Id).then(function (data) {
                    if (data == "400") return logError('Attenzione: allegato non cancellabile! Contattare l\'Help-desk');

                    var index = vm.list.attach.indexOf(item);
                    vm.list.attach.splice(index, 1);
                    //vm.record.stat_numAttach = vm.record.stat_numAttach - 1;
                });
            });
        }
    }
})();
